import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Input,
  Select,
  message,
  Typography,
  Row,
  Col,
  Tag,
  Empty,
  Spin,
} from 'antd';
import {
  PlusOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { parceirosAPI } from '../services/api';
import ImageUpload from '../components/ImageUpload';
import ItemCard from '../components/ItemCard';
import { getImageUrl } from '../utils/getImageUrl';

const { Title } = Typography;
const { Option } = Select;

const ParceirosPage = () => {
  const [parceiros, setParceiros] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingParceiro, setEditingParceiro] = useState(null);
  const [filtro, setFiltro] = useState('');
  const [form] = Form.useForm();

  useEffect(() => {
    loadParceiros();
  }, [filtro]);

  const loadParceiros = async () => {
    setLoading(true);
    try {
      const response = await parceirosAPI.getAll(filtro);
      setParceiros(response.data);
    } catch (error) {
      message.error('Erro ao carregar parceiros');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditingParceiro(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEdit = (parceiro) => {
    setEditingParceiro(parceiro);
    form.setFieldsValue(parceiro);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await parceirosAPI.delete(id);
      message.success('Parceiro deletado com sucesso');
      loadParceiros();
    } catch (error) {
      message.error('Erro ao deletar parceiro');
      console.error(error);
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (editingParceiro) {
        await parceirosAPI.update(editingParceiro._id, values);
        message.success('Parceiro atualizado com sucesso');
      } else {
        await parceirosAPI.create(values);
        message.success('Parceiro criado com sucesso');
      }
      setModalVisible(false);
      loadParceiros();
    } catch (error) {
      message.error('Erro ao salvar parceiro');
      console.error(error);
    }
  };
  const renderParceiroImage = (parceiro) => {
    return parceiro.logo ? (
      <img 
        src={getImageUrl(parceiro.imagem)} 
        alt="Logo" 
        className="card-image"
        style={{ objectFit: 'contain', backgroundColor: '#fff' }}
        onError={(e) => {
          e.target.style.display = 'none';
        }}
      />
    ) : (
      <div className="card-image-placeholder">
        <TeamOutlined style={{ fontSize: 24 }} />
      </div>
    );
  };

  const renderParceiroMeta = (parceiro) => {
    return (
      <Tag color={parceiro.produto === 'CSAP' ? 'blue' : 'green'}>
        {parceiro.produto}
      </Tag>
    );
  };
  return (
    <div className="admin-page-container">      <div className="filter-section">
        <Row style={{ width: '100%' }} justify="space-between" align="middle">
          <Col>
            <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
              Novo Parceiro
            </Button>
          </Col>
          <Col>
            <Select
              placeholder="Filtrar por produto"
              style={{ width: 200 }}
              value={filtro}
              onChange={setFiltro}
              allowClear
            >
              <Option value="CSAP">CSAP</Option>
              <Option value="RHA">RHA</Option>
            </Select>
          </Col>
        </Row>
      </div><Spin spinning={loading}>
        {parceiros.length === 0 ? (
          <Empty 
            description="Nenhum parceiro encontrado"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        ) : (
          <div className="cards-container">
            {parceiros.map(parceiro => (
              <ItemCard
                key={parceiro._id}
                item={parceiro}
                onEdit={handleEdit}
                onDelete={handleDelete}
                renderImage={renderParceiroImage}
                renderMeta={renderParceiroMeta}
                showLink={false}
              />
            ))}
          </div>
        )}
      </Spin>

      <Modal
        title={editingParceiro ? 'Editar Parceiro' : 'Novo Parceiro'}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={() => form.submit()}
        width={600}
        okText="Salvar"
        cancelText="Cancelar"
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="modal-form"
        >
          <Form.Item
            name="nome"
            label="Nome do Parceiro"
            rules={[{ required: true, message: 'Digite o nome do parceiro' }]}
          >
            <Input placeholder="Nome do parceiro" />
          </Form.Item>

          <Form.Item
            name="produto"
            label="Produto"
            rules={[{ required: true, message: 'Selecione o produto' }]}
          >
            <Select placeholder="Selecione o produto">
              <Option value="CSAP">CSAP - Cuidados Saúde Atenção Primária</Option>
              <Option value="RHA">RHA - Reprodução Humana Assistida</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="logo"
            label="Logo"
            rules={[{ required: true, message: 'Faça upload do logo' }]}
          >
            <ImageUpload />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ParceirosPage;
